import React from 'react';

const AuthTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'login', label: 'Sign In' },
    { id: 'register', label: 'Create Account' }
  ];

  return (
    <div className="flex gap-2 p-1 bg-muted rounded-lg mb-6">
      {tabs?.map((tab) => (
        <button
          key={tab?.id}
          onClick={() => onTabChange(tab?.id)}
          className={`
            flex-1 px-4 py-2.5 rounded-md text-sm font-medium transition-smooth
            ${activeTab === tab?.id
              ? 'bg-card text-foreground shadow-elevation-sm'
              : 'text-muted-foreground hover:text-foreground'
            }
          `}
        >
          {tab?.label}
        </button>
      ))}
    </div>
  );
};

export default AuthTabs;